import { InjectionToken } from '@angular/core';

// Crypto Key Constant
export const cryptoBlobKey = new InjectionToken<string>('cryptoBlobKey');
